var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M11.986 7.193V9.86q.002.26-.026.5c-.154 1.8-1.214 2.693-3.167 2.693h-.267a.54.54 0 0 0-.426.214l-.8 1.066c-.354.474-.927.474-1.28 0l-.8-1.066a.62.62 0 0 0-.427-.214h-.267c-2.126 0-3.193-.526-3.193-3.193V7.193c0-1.953.9-3.013 2.693-3.166q.24-.028.5-.027h4.267c2.127 0 3.193 1.067 3.193 3.193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M14.653 4.527v2.666q-.002 2.939-2.693 3.167c.02-.16.026-.327.026-.5V7.193Q11.985 4.002 8.793 4H4.526q-.26-.002-.5.027C4.18 2.233 5.24 1.333 7.193 1.333h4.267c2.126 0 3.193 1.067 3.193 3.194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.997 8.833h.006M6.663 8.833h.006M4.33 8.833h.006"
  })));
};
export default SvgMessages;